/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type DropdownCategories_allCategories$ref = any;
type UnitsPage_allUnitMeasure$ref = any;
export type queries_UnitsPage_recipes_QueryVariables = {||};
export type queries_UnitsPage_recipes_QueryResponse = {|
  +allCategories: ?{|
    +$fragmentRefs: DropdownCategories_allCategories$ref
  |},
  +$fragmentRefs: UnitsPage_allUnitMeasure$ref,
|};
export type queries_UnitsPage_recipes_Query = {|
  variables: queries_UnitsPage_recipes_QueryVariables,
  response: queries_UnitsPage_recipes_QueryResponse,
|};
*/


/*
query queries_UnitsPage_recipes_Query {
  allCategories {
    ...DropdownCategories_allCategories
  }
  ...UnitsPage_allUnitMeasure
}

fragment DropdownCategories_allCategories on RecipeCategoryNodeConnection {
  edges {
    node {
      id
      name
      picture
    }
  }
}

fragment UnitsPage_allUnitMeasure on Query {
  allUnitMeasure(first: 20) {
    totalCount
    edges {
      node {
        id
        code
        description
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "queries_UnitsPage_recipes_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeCategoryNodeConnection",
        "kind": "LinkedField",
        "name": "allCategories",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DropdownCategories_allCategories"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "UnitsPage_allUnitMeasure"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "queries_UnitsPage_recipes_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeCategoryNodeConnection",
        "kind": "LinkedField",
        "name": "allCategories",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeCategoryNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecipeCategoryNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "picture",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnitMeasureNodeConnection",
        "kind": "LinkedField",
        "name": "allUnitMeasure",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UnitMeasureNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UnitMeasureNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "allUnitMeasure(first:20)"
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "code"
        ],
        "handle": "connection",
        "key": "Units_allUnitMeasure",
        "kind": "LinkedHandle",
        "name": "allUnitMeasure"
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "queries_UnitsPage_recipes_Query",
    "operationKind": "query",
    "text": "query queries_UnitsPage_recipes_Query {\n  allCategories {\n    ...DropdownCategories_allCategories\n  }\n  ...UnitsPage_allUnitMeasure\n}\n\nfragment DropdownCategories_allCategories on RecipeCategoryNodeConnection {\n  edges {\n    node {\n      id\n      name\n      picture\n    }\n  }\n}\n\nfragment UnitsPage_allUnitMeasure on Query {\n  allUnitMeasure(first: 20) {\n    totalCount\n    edges {\n      node {\n        id\n        code\n        description\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9cf222dae0156b0677663d7805e907e8';

module.exports = node;
